var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-3",attrs:{"wrap":""}},_vm._l((_vm.products),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"3"}},[_c('Product',{attrs:{"product":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }